import(/* webpackMode: "eager" */ "/opt/neanderthal_website/frontend/src/app/global-error.tsx");
